import auth from '../../middlewares/auth';

export const domainRoutes = [
  {
    path: '/domains',
    component: () =>
      import(/* webpackChunkName: "domains" */ '../../views/domains/Domain'),
    name: 'domains',
    meta: {
      middleware: [auth],
      requiredPermissions: ['domain-manage'],
    },
  },
  {
    path: '/domain/:id',
    component: () =>
      import(
        /* webpackChunkName: "domains" */ '../../views/domains/DomainForm'
      ),
    name: 'update-domain',
    meta: {
      middleware: [auth],
      requiredPermissions: ['domain-manage'],
    },
  },
  {
    path: '/create-domain',
    component: () =>
      import(
        /* webpackChunkName: "domains" */ '../../views/domains/DomainForm'
      ),
    name: 'create-domain',
    meta: {
      middleware: [auth],
      requiredPermissions: ['domain-manage'],
    },
  },
];
